import React, { FC } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

interface IProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'sticky',
      top: theme.custom.topOffset,
      height: `calc(100vh - ${theme.custom.topOffset + theme.spacing(2)}px)`,
      overflowY: 'auto',
      marginRight: theme.spacing(3), // layout spacing,
      paddingBottom: theme.spacing(3),
    },
  });

const StickySidebar: FC<IProps> = ({ children, classes }) => (
  <div className={classes.root}>{children}</div>
);

export default withStyles(styles)(StickySidebar);
